import { Reducer, ReducersMapObject } from 'redux';
import core from '@gin-betting/core';
import banners from '@gin-betting/banners';
import favoriteMarkets from '@gin-betting/favorite-markets';

import { State, FullStateShape, AsyncStateShape, SyncStateShape } from 'types';
import { AppStateRecord } from 'app-constants';
import favorite from 'modules/favorite';
import matchList from 'modules/match-list';
import ui from 'modules/ui';
import promo from 'modules/promo';

const {
    entities,
    viewport: {},
    utils: { logReducerTiming, combineReducers },
} = core;

const stubReducer = (state = null) => state;

const asyncInitialReducers: Record<
    keyof AsyncStateShape,
    typeof stubReducer
> = {
    viewport: stubReducer,
    betslip: stubReducer,
    filters: stubReducer,
    match: stubReducer,
    freebet: stubReducer,
    betsHistory: stubReducer,
    stream: stubReducer,
    restrictions: stubReducer,
};

const syncInitialReducers: {
    [K in keyof Omit<SyncStateShape, 'viewport'>]: Reducer<SyncStateShape[K]>;
} = {
    [entities.constants.NAME]: entities.reducer,
    [ui.constants.NAME]: ui.reducer,
    [favoriteMarkets.constants.NAME]: favoriteMarkets.reducer(),
    [matchList.constants.NAME]: matchList.reducer,
    [matchList.pagination.constants.NAME]: matchList.paginationReducer,
    [favorite.constants.NAME]: favorite.reducer,
    [banners.constants.NAME]: banners.reducer,
    [promo.constants.NAME]: promo.reducer,
};

const initialReducers: {
    [K in keyof FullStateShape]?: Reducer<any>;
} = {
    ...asyncInitialReducers,
    ...syncInitialReducers,
};

export default function createRootReducer(reducers: any): Reducer<State> {
    const appStateShape: ReducersMapObject = logReducerTiming({
        ...initialReducers,
        ...reducers,
    });

    return combineReducers(appStateShape, AppStateRecord);
}
